__webpack_require__.p = "/kw/ar/customer-service/returns-claims/spareparts/";